const doc = [({"da":({"js":({"admin":({"elements":({"show":({"element_with_id":"Element %{element_id}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;